import { Component, OnInit, HostListener } from '@angular/core';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { Constant } from './shared/constant';
import { Router } from '@angular/router';
import { CommonService } from './service/common-service/common.service';
import { InactivityTimerStatus } from './shared/inactivity-timer-status';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'StaticContent';
  inactivityTimeOut: number = Constant.IdleTimeout; // in miliseconds
  finalInactivityTimeOut: number = Constant.FinalInactivityTimeOut; // in miliseconds
  inactivityTimerID: any = -1;
  inactivityTimerStage: any = InactivityTimerStatus.ShowSessionWarningDialog;
  timeOutfunc: any;
  isPopUpAvailable:boolean=false;
  constructor(public dialog: MatDialog, public router: Router, public commonService: CommonService) {
  }

  ngOnInit(): void {
    this.commonService.SessionExpiryObservable.subscribe(startInactivityTimer => {
      if (startInactivityTimer !== undefined) {
        this.onActivate();
      }
    });
  }

  onActivate(): void {
    if (this.router.url != undefined && this.router.url != '/') {
      this.StartInactivityTimer();
    }
  }

  showSessionWarningDialog=()=> {
    this.isPopUpAvailable=true;
    this.StartInactivityTimer();
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: 'Session Expiring!',
      message: 'Tutorial session expiring in ' + (this.finalInactivityTimeOut / 60000) + ' minutes due to inactivity. Please click Continue if you wish to return to taking the Tutorial. Otherwise, your session will end and you will be returned to your MyATI portal',
      button1Text: 'Continue',
      button2Text: '',
      dialogType: 1
    };
    dialogConfig.panelClass = 'session-popup';
    const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      this.isPopUpAvailable=false;
      this.RestartInactivityTime();
    });
  }
  InactivityTimerExpired(timeOutfunc: any) {
    console.log(timeOutfunc);
    this.inactivityTimerID = setTimeout(timeOutfunc, this.inactivityTimeOut);
  }
  StartInactivityTimer() {
    this.StopInactivityTimer();
    switch (this.inactivityTimerStage) {
      case InactivityTimerStatus.ShowSessionWarningDialog:
        this.timeOutfunc = this.showSessionWarningDialog;
        this.inactivityTimerStage = InactivityTimerStatus.TimeOutandRedirect;
        this.inactivityTimeOut = Constant.IdleTimeout;
        break;
      case InactivityTimerStatus.TimeOutandRedirect:
        this.inactivityTimeOut = this.finalInactivityTimeOut;
        this.timeOutfunc = this.timeOutandRedirect;
    }
    this.InactivityTimerExpired(this.timeOutfunc);
  }
  StopInactivityTimer() {
    if (this.inactivityTimerID != -1)
      clearTimeout(this.inactivityTimerID);
  }
  RestartInactivityTime() {
    this.inactivityTimerStage = InactivityTimerStatus.ShowSessionWarningDialog;
    this.StartInactivityTimer();
  }

  timeOutandRedirect=()=> {
    this.dialog.closeAll();
    window.self.parent.postMessage('InactivityTimerExpired', Constant.OriginUrlPattern);
  }

  @HostListener('window:message', ['$event'])
  OnMessage(msg: any) {
    let dataInfo = msg.data;
    if (dataInfo && typeof dataInfo === 'string' && dataInfo.indexOf('{') !== -1 && dataInfo.indexOf('|') === -1) {
      let eventType = JSON.parse(msg.data)?.MessageName;
      if (eventType === 'Click' || eventType === 'SimulationHeartbeat') {
        if(!this.isPopUpAvailable)
          this.RestartInactivityTime();
      }
    }
  }
}